import { Link } from 'react-router-dom';
import { getMoonPhase } from '../../services/ephemeris';

function formatDate(d: Date): string {
  const days = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
  return `${days[d.getDay()]} ${d.getDate()}`;
}

const MOON_GLYPH: Record<string, string> = {
  'New Moon': '●', 'Waxing Crescent': '☽', 'First Quarter': '◑',
  'Waxing Gibbous': '◕', 'Full Moon': '○', 'Waning Gibbous': '◔',
  'Last Quarter': '◐', 'Waning Crescent': '☾',
};

interface DayInfo {
  date: Date;
  label: string;
  moonGlyph: string;
  moonName: string;
  isToday: boolean;
}

const days: DayInfo[] = Array.from({ length: 7 }).map((_, i) => {
  const d = new Date();
  d.setDate(d.getDate() + i);
  const moon = getMoonPhase(d);
  return {
    date: d,
    label: formatDate(d),
    moonGlyph: MOON_GLYPH[moon.name] ?? '☾',
    moonName: moon.namePt,
    isToday: i === 0,
  };
});

export function CelestialTimeline() {
  return (
    <section style={{ marginBottom: '2rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.875rem' }}>
        <h2 style={{ fontFamily: 'var(--font-display)', fontStyle: 'italic', fontWeight: 400, fontSize: 'var(--text-18)', color: 'var(--bg)', margin: 0 }}>
          Próximos 7 dias
        </h2>
        <Link to="/agenda" style={{ fontSize: 'var(--text-13)', color: 'var(--petrol)', fontFamily: 'var(--font-body)', textDecoration: 'none' }}>
          Ver agenda →
        </Link>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '1px', backgroundColor: 'var(--line-soft)' }}>
        {days.map(day => (
          <Link
            key={day.date.toISOString()}
            to="/agenda"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '0.35rem',
              padding: '0.75rem 0.25rem',
              backgroundColor: day.isToday ? 'var(--bg-elevated)' : 'var(--bg-surface)',
              borderTop: day.isToday ? '1px solid var(--petrol)' : 'none',
              textDecoration: 'none',
              transition: 'background-color var(--transition-fast)',
            }}
            title={day.moonName}
          >
            <span style={{
              fontSize: '11px',
              fontFamily: 'var(--font-body)',
              color: day.isToday ? 'var(--petrol)' : 'var(--celeste-soft)',
              textTransform: 'capitalize',
            }}>
              {day.label}
            </span>
            <span style={{
              fontFamily: 'var(--font-display)',
              fontSize: '1.25rem',
              color: day.isToday ? 'var(--petrol)' : 'var(--celeste-soft)',
              lineHeight: 1,
            }}>
              {day.moonGlyph}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
